import type { CanDeactivateFn } from '@angular/router';

/** The application shell keeps recording visible; internal navigation never stops it. */
export const flowLiveLeaveGuard: CanDeactivateFn<unknown> = () => true;
